import isGHMC, { formattedDate, formattedDateTypeTwo, getCurrentDate, getFirstDateOfMonth } from "../../../../Common/helper/helpar";
import Modal from "react-bootstrap/Modal";
import { MonthWiseAttendanceFilters } from "../../Attendance/MonthWiseAttendanceSummary/MonthWiseAttendanceFilters";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    TablePagination,
    Paper,
} from "@mui/material";

import { useEffect, useState } from "react";
import { TableLoader } from "../../../../Common/ShimmerLoader";
import { InnerTippingFeeExport } from "./InnerTippingFeeExport";
import { useNavigate } from "react-router-dom";
import TippingFeeCalculationStore from "./store/TippingFeeCalculationStore";

const TippingFeeCalculationInnerReport = () => {
    const {  loading, fetchTippingFeeCalculationInnerZoneReport, tippingFeeInnerZoneReportData } = TippingFeeCalculationStore()
    const navigate = useNavigate()
    useEffect(() => {
        const storedFilters = localStorage.getItem("tippingFeeFilters");
        if (storedFilters) {
            const parsedFilters = JSON.parse(storedFilters);
            fetchTippingFeeCalculationInnerZoneReport(parsedFilters)
        }
    }, []);


    const totalGHMCTrips = tippingFeeInnerZoneReportData.reduce((sum, item) => sum + (parseFloat(item.ghmC_Trips) || 0), 0);
    const totalHMSWTrips = tippingFeeInnerZoneReportData.reduce((sum, item) => sum + (parseFloat(item.himsW_Trips) || 0), 0);
    const totalTrips = tippingFeeInnerZoneReportData.reduce((sum, item) => sum + (parseFloat(item.total_Trips) || 0), 0);
    const totalGHMCTonnage = tippingFeeInnerZoneReportData.reduce((sum, item) => sum + (parseFloat(item.ghmC_NetWeight) || 0), 0);
    const totalHMSWTonnage = tippingFeeInnerZoneReportData.reduce((sum, item) => sum + (parseFloat(item.himsW_NetWeight) || 0), 0);
    const totalTonnage = tippingFeeInnerZoneReportData.reduce((sum, item) => sum + (parseFloat(item.total_Tonnage) || 0), 0);


    const isProd = isGHMC();
    const headerStyles = {
        textAlign: "center",
        border: "1px solid #ddd",
        borderRight: "none",
        padding: "10px",
        color: "#fff",
        backgroundColor: isProd ? "#004554" : "#EC1117",
    };
    const cellStyles = {
        textAlign: "center",
        border: "1px solid #ddd",
        borderRight: "none",
        padding: "10px",
        whiteSpace: "normal",
    };

    return (
        <>
            <div style={{ width: "100%" }}>
                <div className="content">
                    <div className="page-content">
                      <div className="top-header page-title">
                        <span>Zone-Wise Tipping Fee Report</span>
                      </div>
                        <div className="d-flex justify-content-end align-items-end">
                            <button className="btn btn-secondary" onClick={() => navigate(-1)}>
                                Back
                            </button>
                            <InnerTippingFeeExport />
                        </div>

                        <div className="page-header text-start">
                            <div className="card">
                                <div className="card-body">
                                    <TableContainer
                                        component={Paper}
                                        sx={{
                                            width: "100%",
                                            border: "1px solid #ccc",
                                            maxHeight: 700,
                                        }}
                                    >
                                        <Table stickyHeader aria-label="sticky table">
                                            <TableHead
                                                className={`${isProd ? "bg-ghmc" : "bg-swm"}`}
                                                style={{ position: "sticky", top: 0 }}
                                            >
                                                <TableRow>
                                                    <TableCell rowSpan={2} sx={headerStyles}>S.No</TableCell>
                                                    <TableCell rowSpan={2} sx={headerStyles}>Zone</TableCell>
                                                    <TableCell colSpan={4} sx={headerStyles} style={{ textAlign: "center" }}>
                                                        Trips
                                                    </TableCell>
                                                    <TableCell colSpan={4} sx={headerStyles} style={{ textAlign: "center" }}>
                                                        Tonnage
                                                    </TableCell>

                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={headerStyles}>GHMC</TableCell>
                                                    <TableCell sx={headerStyles}>HMSW Hire</TableCell>
                                                    <TableCell sx={headerStyles}>HMSW</TableCell>
                                                    <TableCell sx={headerStyles}>Total</TableCell>
                                                    <TableCell sx={headerStyles}>GHMC</TableCell>
                                                    <TableCell sx={headerStyles}>HMSW Hire</TableCell>
                                                    <TableCell sx={headerStyles}>HMSW</TableCell>
                                                    <TableCell sx={headerStyles}>Total</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {tippingFeeInnerZoneReportData?.map((item, index) => (
                                                    <TableRow
                                                        key={index}
                                                        sx={{
                                                            backgroundColor: index % 2 === 1 ? "rgba(0, 69, 84, 0.04)" : "#ffffff",
                                                        }}
                                                    >
                                                        <TableCell sx={cellStyles}>{index + 1}</TableCell>
                                                        <TableCell sx={cellStyles}>{item.zoneName}</TableCell>
                                                        <TableCell sx={cellStyles}>{item.ghmC_Trips}</TableCell>
                                                        <TableCell sx={cellStyles}>{item.ghmcTonnage}</TableCell>
                                                        <TableCell sx={cellStyles}>{item.himsW_Trips}</TableCell>
                                                        <TableCell sx={cellStyles}>{item.total_Trips}</TableCell>
                                                        <TableCell sx={cellStyles}>{item.ghmC_NetWeight}</TableCell>
                                                        <TableCell sx={cellStyles}></TableCell>
                                                        <TableCell sx={cellStyles}>{item.himsW_NetWeight}</TableCell>
                                                        <TableCell sx={cellStyles}>{item.total_Tonnage}</TableCell>
                                                    </TableRow>
                                                ))}
                                                <TableRow>
                                                <TableCell sx={cellStyles} ></TableCell>
                                                    <TableCell sx={cellStyles} ><strong>Total</strong></TableCell>
                                                        <TableCell sx={cellStyles}><strong>{totalGHMCTrips}</strong></TableCell>
                                                        <TableCell sx={cellStyles}><strong></strong></TableCell>
                                                        <TableCell sx={cellStyles}><strong>{totalHMSWTrips}</strong></TableCell>
                                                        <TableCell sx={cellStyles}><strong>{totalTrips}</strong></TableCell>
                                                        <TableCell sx={cellStyles}><strong>{totalGHMCTonnage}</strong></TableCell>
                                                        <TableCell sx={cellStyles}><strong></strong></TableCell>
                                                        <TableCell sx={cellStyles}><strong>{totalHMSWTonnage}</strong></TableCell>
                                                        <TableCell sx={cellStyles}><strong>{totalTonnage}</strong></TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    {/* </Paper> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
};

export default TippingFeeCalculationInnerReport;
